import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
/** @public */
const formatDate = (dateStr, dateFormat = 'MM/dd/yyyy') => {
  if (dateStr && dateStr.length > 0) {
    return format(parse(dateStr, PRICELINE_DATE_FORMAT, new Date()), dateFormat);
  }
  return '';
};
export default formatDate;